/* ==========================================================================
   In-stage text is HTML at true pixel sizes (never SVG <text>, never scaled
   by the camera). The stage svg carries role=img and the aria summary, so
   every label here is aria-hidden. Placement maths is in scene.css; small
   plates drop the labels (scene.css container queries).
   ========================================================================== */

const upper = (text, lang) => text.toLocaleUpperCase(lang)

/**
 * Camera-tracked labels over a film: the Detail caption and the end-card
 * register label, which sits on its leader's shelf at `register` (stage units).
 */
export function StageLabels({ stage, lang, register }) {
  const [x, y] = register
  return (
    <div className="pp__labels" aria-hidden="true">
      {stage.detail && <span className="pp-label pp-label--detail legend">{upper(stage.detail, lang)}</span>}
      <span className="pp-label pp-label--reg" style={{ '--ax': x, '--ay': y }}>
        <span className="pp-reg-service">{stage.register.service}</span>
        <span className="pp-reg-mark legend">{upper(stage.register.mark, lang)}</span>
      </span>
    </div>
  )
}
